import { render, staticRenderFns } from "./ConnectorStaticPointsTable.vue?vue&type=template&id=c40a2452&scoped=true"
import script from "./ConnectorStaticPointsTable.vue?vue&type=script&lang=js"
export * from "./ConnectorStaticPointsTable.vue?vue&type=script&lang=js"
import style0 from "./ConnectorStaticPointsTable.vue?vue&type=style&index=0&id=c40a2452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40a2452",
  null
  
)

export default component.exports